import { Component, input, output } from '@angular/core';


@Component({
  selector: 'app-address-predictions',
  standalone: true,
  imports: [],
  templateUrl: './address-predictions.component.html',
  styleUrls: ['./address-predictions.component.css'],
})
export class AddressPredictionsComponent {
  isLoading = input.required<boolean>();
  predictions = input.required<google.maps.places.PlacePrediction[]>();
  predictionSelected = output<google.maps.places.PlacePrediction>();

  onSelect(prediction: google.maps.places.PlacePrediction): void {
    this.predictionSelected.emit(prediction);
  }
}
